import React from 'react';
import styles from './completingModal.module.scss';
import Modal from '@src/components/modal/Modal';

type Props = {
  open: boolean;
  onClose: () => void;
};

function CompletingModal(props: Props) {
  const { open, onClose } = props;

  return (
    <Modal global={false} open={open} onClose={onClose} className={styles.wrapper} closeButton={false} closeOnOverlayClick={false}>
      <div className={styles.opContent}>
        <div className={styles.opCongrateView}><span><strong>Congratulations</strong> on completing the lesson! You can now close this window.</span></div>
      </div>
    </Modal>
  );
}

export default CompletingModal;
